import React, { useCallback, useState } from 'react';

import { Flex } from 'common/components/Flex';
import { Radio } from 'common/components/Radio';
import { Direction } from 'common/enums/Direction';
import type { ArticleSortOption } from 'common/enums/SortOption';
import type { SortParams } from 'common/types/SortAndFilter';

interface SortSectionProps extends SortParams {
  onChange: (order: ArticleSortOption) => void;
}

const RADIO_SIZE = 20;

const SortSection = ({ order: activeSortOption, sortOptions, onChange }: SortSectionProps) => {
  const [order, setOrder] = useState(activeSortOption);
  const onSortOptionChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newOrder = event.target.value as ArticleSortOption;
      setOrder(newOrder);
      onChange(newOrder);
    },
    [onChange]
  );

  return (
    <Flex flexDirection="column" pl="sp_16" pr="sp_12">
      {sortOptions.map(({ option, localized }) => (
        <Radio
          iconSize={RADIO_SIZE}
          direction={Direction.Rtl}
          onChange={onSortOptionChange}
          defaultChecked={order === option}
          label={localized}
          value={option}
          key={option}
          name="order"
          customLabelStyles={{ mb: 'sp_0' }}
        />
      ))}
    </Flex>
  );
};

export default SortSection;
